import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { $http, $request } from './utils/http'
import Common from './utils/common'

import './assets/css/common.scss'

const app = createApp(App)
app.config.globalProperties.$http = $http
app.config.globalProperties.$request = $request
app.config.globalProperties.$common = Common

router.beforeEach((to, from, next) => {
    if (to.path !== '/' && to.path !== '/rule') {
        let userInfo = JSON.parse(JSON.stringify(store.state.userInfo))
        if (!userInfo.token) {
            next('/')
        } else {
            next()
        }
    } else {
        next()
    }
})

if (process.env.NODE_ENV == 'development') {
    app.config.globalProperties.devtools = true
} else {
    app.config.globalProperties.devtools = false
}

app.use(store).use(router).mount('#app')
